var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.item.originLinkTo)?_c('nuxt-link',{attrs:{"to":_vm.item.originLinkTo,"target":"_blank"}},[_c('BBcode',{attrs:{"text":_vm.item.origin_string}})],1):_c('span',[_c('BBcode',{attrs:{"text":_vm.item.origin_string}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }